import { render, staticRenderFns } from "./MembershipView-practioner.vue?vue&type=template&id=8335709a&scoped=true"
import script from "./MembershipView-practioner.vue?vue&type=script&lang=js"
export * from "./MembershipView-practioner.vue?vue&type=script&lang=js"
import style0 from "./MembershipView-practioner.vue?vue&type=style&index=0&id=8335709a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8335709a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VContainer,VForm,VSelect,VTextField})
